import React, { Component } from 'react';
import * as Common from './../helpers/Common';
import * as Config from '../config/Config';
import * as User from '../helpers/User';

const $= window.$;

class MyBookmarks extends Component {
	constructor(props) {
		super(props);
        this.state={

            bookmarks : [],

        };

       this.getBookmarkDetails = this.getBookmarkDetails.bind(this);
       this.removeBookmark = this.removeBookmark.bind(this);
    

	}



	getBookmarkDetails(){

		let learnerID = Common.getUserData("id", true);
   		 Common.reactLoader("show", "Please wait...");
	    	fetch(Config.domainUrl+'resources/bookmark-details', {
	                method: 'POST',
	                headers: {
	                  'Accept': 'application/json',
	                  'Content-Type': 'application/json',
										'Authorization':'Bearer ' +Common.getTokenData()
	                },

	                  body: JSON.stringify({
	                    learnerID:learnerID
	                  })
	                }).then((response) => response.json())
	               .then((responseJson) => {
	               	//alert(JSON.stringify(responseJson)) ;
	               	Common.reactLoader("hide");
	                this.setState({
	                    bookmarks : responseJson.bookmark_details,

	                });


	   		 });


	}

	 handler(type,data_sent){

	     this.props.handler(type,data_sent);

	}

	removeBookmark(chap_id){

		window.swal({
		      //title: 'Remove!',
		      text: 'Remove this bookmark?',
		     // type: 'question',
		      showCancelButton: true,
		      confirmButtonColor: '#14a430',
					cancelButtonColor: '#0082c9',
					animation: false,
		      confirmButtonText: 'Ok'
		    }).then((result) => {
		      	if(result){
			    	let learnerID = Common.getUserData("id", true);
				    	fetch(Config.domainUrl+'resources/bookmark', {
				                method: 'POST',
				                headers: {
				                  'Accept': 'application/json',
				                  'Content-Type': 'application/json',
													'Authorization':'Bearer ' +Common.getTokenData()
				                },

				                  body: JSON.stringify({
				                    chap_id:chap_id,learnerID:learnerID
				                  })
				                }).then((response) => response.json())
				               .then((responseJson) => {
				               //	alert(JSON.stringisy(responseJson));
				                 if (responseJson.status == 0) {
							       Common.message(responseJson.message,responseJson.errors,'error');
							    }else{
							      Common.message('Success',responseJson.message,'success');
							      this.getBookmarkDetails();
							    }


				   		 });

		      	}
		    });
	}


	 componentDidMount() {
        this.getBookmarkDetails();
    }



		render() {
			// let bookmarks = "";
			let bookmarks = this.state.bookmarks.map((books,i)=>{
				let chap = books.chapters.map((chapt,k)=>{
					var chap_sub = books.sent_id+'__'+chapt.chapter_id_pk;
					return(
							<div key={chapt.chapter_id_pk} id="bmark_link">
								<ul className="sub">
									<li>
										<div className="right"><a href="javascript:void(0);" onClick={() =>{this.removeBookmark(chapt.chapter_id_pk)} } title="Un-Bookmark"><img src={process.env.PUBLIC_URL+"/images/remove_cwr.jpg"} width="17" height="17" border="0" /></a>
										</div>
										<a href="javascript:void(0);" onClick={e=>this.handler('getback',chap_sub)} >{chapt.chapter_name}</a>
									</li>
								</ul>
							</div>
						)
				})
				return(
						<div key={`subject_div_${books.subject_id}`} id={"subject_div_"+books.subject_id}>
							<div className="mybook-blue">
								{books.subject}
							</div>
							<div id={"chapter_id_"+books.bookmark_id}>
							{chap}
							</div>
						</div>

					)
			});

			return (
				<div className="main-inner">
					<div className="border-box">
						<div className="title-box-gray">My Bookmarks</div>
	                    <section id="semana-scroll-inner" className="scrollbar">
	                        <section className="viewport">
	                            <section className="overview">
	                                <div className="inner-content">
										<div className="chap_main1" id="chapter_latest">
											{(!bookmarks.length)?<p>No Bookmarks</p>:bookmarks}
										</div>
										<div className="button cwbookmarkbtn"><input type="button" onClick={e=>this.handler('getback')} name="btnsubmit" value="Continue"  className="button_org" alt="Continue" title="Continue"/></div>
										<div style={{clear:'both'}}></div>
									</div>
	                            </section>
	                        </section>
	                    </section>
					</div>
                </div>
			);
		}
}

export default MyBookmarks;



// WEBPACK FOOTER //
// ./src/learning_resources/MyBookmarks.js